module.exports = __webpack_public_path__ + "img/79870657bd9229c93795b8898870d756.9ec1d68b.png";